import { Controller } from "@hotwired/stimulus"

// Interruttore (Radix Switch): aggiorna data-state, aria-checked e l'eventuale campo nascosto; emette "switch:change".
export default class extends Controller {
  static targets = ["thumb", "input"]

  toggle() {
    if (this.element.disabled) return
    const checked = this.element.dataset.state !== "checked"
    const state = checked ? "checked" : "unchecked"
    this.element.dataset.state = state
    this.element.setAttribute("aria-checked", String(checked))
    if (this.hasThumbTarget) this.thumbTarget.dataset.state = state
    if (this.hasInputTarget) {
      this.inputTarget.value = String(checked)
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.dispatch("change", { detail: { checked } })
  }
}
